import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { PageService } from './../../../../../core/services/page/page.service';
import { Component } from '@angular/core';
import {
  Successpage,
  serverError,
} from './../../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-pageintervanant',
  templateUrl: './pageintervanant.component.html',
  styleUrls: ['./pageintervanant.component.css'],
})
export class PageintervanantComponent {
  idActor: any;
  company_id: any;
  company: any;
  subPageIds: any[] = [];
  /* array */
  listPages: any;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private pageActorService: PageService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.idActor = this.localStorageService.getData('roleUseresn');
    this.company = this.localStorageService.getData('typeintervenant');
    this.getListPagesActorintervenant();
  }

  /* get list  pages by actor */
  getListPagesActorintervenant() {
    this.spinner.show();
    this.pageActorService
      .listPageActorIntervenant()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('reponse', res);
          if (res.status == 200) {
            this.spinner.hide();
            this.listPages = res.data;
            console.log('pageeeeeeeeeintervenant', this.listPages);
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }
  changeSelection(subPage: any) {
    console.log('subpage', subPage);
    this.subPageIds = subPage.id;
  }

  changeSubPageState() {
    this.spinner.show();
    let data = {
      company_id: this.localStorageService.getData('clientConnected'),
      // company_id:this.idActor,
      sub_page_id: this.subPageIds,
    };
    console.log('data', data);
    this.pageActorService
      .changeSubPageStateIntervenant(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            // this.listPages = res.data
            this.toastr.success(Successpage);
          }
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
